// base url
export const BASE_URL = 'https://airsofter.world';
// rest api url
export const API_URL = `${BASE_URL}/api/web/v1`;
// full month names array
export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];
// full days names array
export const DAY_NAMES = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];
// days abbreviation array
export const D_NAMES = DAY_NAMES.map(dw => dw.substr(0, 3));



// WEBPACK FOOTER //
// ./src/utils/const.js